import { forwardRef } from 'react'
import { Box, useMediaQuery } from '@mui/material'
import MonthlyCalendar from '../components/monthlyCalendar'
import { useTheme } from '@emotion/react'

const CalendarContent = forwardRef(({ calendarValue, filters, apiFilter }, ref) => {
  const theme = useTheme()
  const tablet = useMediaQuery(theme.breakpoints.up('tablet'))

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        borderBottom: '1px solid #E5E5E5',
        borderRadius: '4.5px',
        overflow: 'auto',
        maxHeight: { xs: 'calc(100vh - 200px)', md: 'calc(100vh - 197px)' },
        bgcolor: 'white.main',
        width: 1,
      }}
      className="scrollbar"
    >
      <MonthlyCalendar
        ref={ref}
        calendarValue={calendarValue}
        filters={filters}
        apiFilter={apiFilter}
      />
    </Box>
  )
})

export default CalendarContent
